<template>
  <div v-if="region === 'uk'"></div>
  <div v-else-if="region === 'forex'"></div>
  <div v-else-if="region === 'mena'"></div>
  <div v-else-if="region === 'latam'"></div>
  <div v-else-if="region === 'qa-uk'"></div>
  <div v-else>
    <div class="content">
      <div>
        <img
          src="/assets/images/logo_tradeview_full_dark.svg"
          class="collapsed-logo"
        />
        <ConsoleHeaderIndicator
          :label="this.$t('consoleHeader.account')"
          :value="accountInfo.login"
        ></ConsoleHeaderIndicator>
        <ConsoleHeaderIndicator
          :label="this.$t('consoleHeader.balance')"
          :value="balance"
        ></ConsoleHeaderIndicator>
        <ConsoleHeaderIndicator
          :label="this.$t('consoleHeader.equity')"
          :value="equity"
        ></ConsoleHeaderIndicator>
        <ConsoleHeaderIndicator
          :label="this.$t('consoleHeader.free')"
          :value="free_margin"
        ></ConsoleHeaderIndicator>
        <ConsoleHeaderIndicator
          :label="this.$t('consoleHeader.margin')"
          :value="accountInfo.margin + '%'"
        ></ConsoleHeaderIndicator>
        <ConsoleHeaderIndicator
          v-if="showStatus"
          :label="this.$t('consoleHeader.status')"
          :value="accountInfo.enable"
        ></ConsoleHeaderIndicator>
      </div>

      <div>
        <SelectLanguage
          class="cabinet-login-language"
          v-model="language"
        ></SelectLanguage>
        <ConsoleHelloUser></ConsoleHelloUser>
        <button class="dark-button" @click="attemptLogout">
          {{ $t("consoleHeader.logout") }}
        </button>
      </div>
    </div>
    <!-- Modal logout button-->
    <Modal
      v-if="showDialog"
      @close="showDialog = false"
      dialog-style="logout-modal"
    >
      <template #header>
        <h3>{{ $t("consoleHeader.confirm") }}</h3>
      </template>
      <template #body>
        <div>
          <h3>{{ $t("consoleHeader.confirm") }}</h3>
          <br />
          <p>{{ $t("consoleHeader.outModal") }}</p>
        </div>
      </template>
      <template #footer>
        <div>
          <button @click="logout" class="red-button">
            {{ $t("consoleHeader.yes") }}
          </button>
          <button @click="showDialog = false" class="red-button">
            {{ $t("consoleHeader.not") }}
          </button>
        </div>
      </template>
    </Modal>
  </div>
</template>

<script>
import { Auth } from "aws-amplify";
import ConsoleHeaderIndicator from "@/components/cabinet/ConsoleHeaderIndicator";
import ConsoleAvailableBalance from "@/components/cabinet/ConsoleAvailableBalance";
import ConsoleHelloUser from "@/components/cabinet/ConsoleHelloUser";
import SelectLanguage from "@/components/SelectLanguage";
import Modal from "@/components/Modal";

import {
  getCurrentInstance,
  onMounted,
  onUnmounted,
  ref,
} from "@vue/runtime-core";
import { computed } from "@vue/reactivity";
import { useRouter } from "vue-router";
import { useStore } from "vuex";

export default {
  name: "ConsoleHeader",
  components: {
    Modal,
    ConsoleHeaderIndicator,
    ConsoleAvailableBalance,
    ConsoleHelloUser,
    SelectLanguage,
  },
  data() {
    return {
      language: this.$i18n.locale,
      isInactive: false,
      userActivityThrottlerTimeout: null,
      userActivityTimeout: null,
    };
  },

  mounted() {
    this.language = this.$i18n.locale;
    //console.log("holaa  " + this.language);
  },

  watch: {
    language() {
      this.changeLocale(this.language);
    },
  },

  methods: {
    changeLocale(locale) {
      //console.log("changeee");
      //console.log(locale);
      this.$i18n.locale = locale;
    },

    activateActivityTracker() {
      window.addEventListener("mousemove", this.userActivityThrottler);
      window.addEventListener("scroll", this.userActivityThrottler);
      window.addEventListener("keydown", this.userActivityThrottler);
      window.addEventListener("resize", this.userActivityThrottler);
    },

    deactivateActivityTracker() {
      window.removeEventListener("mousemove", this.userActivityThrottler);
      window.removeEventListener("scroll", this.userActivityThrottler);
      window.removeEventListener("keydown", this.userActivityThrottler);
      window.removeEventListener("resize", this.userActivityThrottler);
    },

    resetUserActivityTimeout() {
      clearTimeout(this.userActivityTimeout);

      this.userActivityTimeout = setTimeout(() => {
        this.userActivityThrottler();
        this.logout();
      }, 2000000);
    },

    userActivityThrottler() {
      if (this.isInactive) {
        this.isInactive = false;
      }

      if (!this.userActivityThrottlerTimeout) {
        this.userActivityThrottlerTimeout = setTimeout(() => {
          this.resetUserActivityTimeout();
          clearTimeout(this.userActivityThrottlerTimeout);
          this.userActivityThrottlerTimeout = null;
        }, 180000);
      }
    },
  },

  beforeMount() {
    this.activateActivityTracker();
  },

  beforeDestroy() {
    this.deactivateActivityTracker();
    clearTimeout(this.userActivityTimeout);
    clearTimeout(this.userActivityThrottlerTimeout);
  },

  setup() {
    const router = useRouter();
    const store = useStore();

    let showDialog = ref(false);
    let accountInfo = ref([]);
    let showStatus = ref(false);
    let balance = ref(0);
    let equity = ref(0);
    let free_margin = ref(0);
    let status = ref(null);
    const region = ref(process.env.VUE_APP_CABINET_ORIGIN);

    const internalInstance = getCurrentInstance();
    const emitter = internalInstance.appContext.config.globalProperties.emitter;

    onMounted(() => {
      load();

      emitter.on("userUpdated", () => {
        load();
      });

      /*       emitter.on('accountUpdated', () => {
        console.log('--- ACTIVE ACCOUNT UPDATED ---')
        // accountInfo.value = store.state.activeAccount
        // accountInfo.value.status = getNiceStatus(accountInfo.value.status)
        // console.log(accountInfo.value.id)
      })
      */
    });

    onUnmounted(() => {
      emitter.off("userUpdated");
      emitter.off("accountUpdated");
    });

    const load = () => {
      if (!store.state.user) {
        return;
      }

      if (
        store.state.user !== null &&
        store.state.user.registerStatus === "ACTIVE"
      ) {
        showStatus.value = true;
      }

      accountInfo.value.balance = 0;
      accountInfo.value.equity = 0;
      accountInfo.value.free_margin = 0;
      accountInfo.value.margin = 0;
      accountInfo.value.leverage = 0;
      accountInfo.value.enable = 0;
      accountInfo.value.login = 0;
      accountInfo.value.currency = "EUR";
      let storedAccounts = localStorage.getItem("Accountslv4");
      console.log(storedAccounts);
      if (
        storedAccounts == null ||
        storedAccounts == "undefined" ||
        storedAccounts == undefined
      ) {
        getNiceStatus(accountInfo.value.enable);
      } else {
        let _accountInfo = JSON.parse(storedAccounts);
        accountInfo.value = _accountInfo[0];
        getNiceStatus(accountInfo.value.enable);
      }
      allow2;
      balance.value = new Intl.NumberFormat("en-US", {
        currency: accountInfo.value.currency,
        minimumFractionDigits: 0,
      }).format(accountInfo.value.balance);
      equity.value = new Intl.NumberFormat("en-US", {
        currency: accountInfo.value.currency,
        minimumFractionDigits: 0,
      }).format(accountInfo.value.equity);
      free_margin.value = new Intl.NumberFormat("en-US", {
        currency: accountInfo.value.currency,
        minimumFractionDigits: 0,
      }).format(accountInfo.value.free_margin);
    };

    const allow2 = computed(() => {
      return accountInfo;
    });

    const getNiceStatus = (status) => {
      switch (status) {
        case 1:
          return (accountInfo.value.enable = "Active");
        case 0:
          return (accountInfo.value.enable = "Inactive");
        default:
          return (accountInfo.value.enable = "-");
      }
    };

    const logout = async () => {
      // console.log('logging out...')
      localStorage.removeItem("storedAccounts");
      localStorage.removeItem("typeAccount");
      localStorage.removeItem("activeAccount");
      localStorage.removeItem("Accountsdm5");
      localStorage.removeItem("Accountsdm4");
      localStorage.removeItem("Accountslv4");
      localStorage.removeItem("Accountslv5");
      localStorage.removeItem("DemoAccounts");
      localStorage.removeItem("UserData");
      localStorage.removeItem("UserPreference");
      localStorage.removeItem("DepositMethods");
      localStorage.removeItem("form_procces");
      localStorage.removeItem("accountType");
      try {
        await Auth.signOut();
        router.replace("/login").catch((err) => {});
        showDialog.value = false;
      } catch (error) {
        // console.log('error signing out: ', error)
        showDialog.value = false;
      }
    };

    const attemptLogout = () => {
      // console.log('attempting logout...')
      // this.$refs['logout-modal'].show();
      showDialog.value = true;
    };

    return {
      logout,
      attemptLogout,
      accountInfo,
      status,
      balance,
      equity,
      free_margin,
      showDialog,
      showStatus,
      allow2,
      region,
    };
  },
};
</script>